(function () {
  const store = window.ScrubLabTeams.store;

  store.productCache = {};

store.getVariantInventory = function (productHandle, variantId) {
  const inventoryElement = [...document.querySelectorAll(
    '[data-team-product-inventory]'
  )].find((element) => {
    return element.dataset.teamProductInventory === productHandle;
  });

  if (!inventoryElement) return null;

  try {
    const inventory = JSON.parse(inventoryElement.textContent);
    return inventory[String(variantId)] || null;
  } catch (error) {
    console.error('Unable to read product inventory:', error);
    return null;
  }
};

  store.money = function (cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }

    return `$${(cents / 100).toFixed(2)}`;
  };

  store.fetchProduct = async function (handle) {
    if (store.productCache[handle]) {
      return store.productCache[handle];
    }

    const response = await fetch(`/products/${handle}.js`);

    if (!response.ok) {
      throw new Error(`Could not load product: ${handle}`);
    }

    const product = await response.json();

    store.productCache[handle] = product;

    return product;
  };

  store.getVariantByOptions = function (product, selectedOptions) {
    return product.variants.find((variant) => {
      return variant.options.every((option, index) => {
        return option === selectedOptions[index];
      });
    });
  };

  store.getDefaultSelectedOptions = function (product) {
    const firstAvailableVariant = product.variants.find((variant) => variant.available);
    const fallbackVariant = firstAvailableVariant || product.variants[0];

    return fallbackVariant ? fallbackVariant.options : [];
  };

store.getProductOptionsMarkup = function (product, selectedOptions) {
  if (!product.options || !product.options.length) return '';

  return product.options.map((option, optionIndex) => {

    // Shopify may return an option object instead of a string.
    const optionName =
      typeof option === 'string'
        ? option
        : option.name || `Option ${optionIndex + 1}`;

    const values = [
      ...new Set(
        product.variants.map(
          (variant) => variant.options[optionIndex]
        )
      )
    ];

    return `
      <div class="team-builder__option-group">
        <span>${optionName}</span>

        <div class="team-builder__option-values">
          ${values.map((value) => {

            const isSelected =
              selectedOptions[optionIndex] === value;

            const isAvailable = product.variants.some((variant) => {
              if (!variant.available) return false;

              return variant.options.every((optionValue, index) => {
                return index === optionIndex
                  ? optionValue === value
                  : optionValue === selectedOptions[index];
              });
            });

            return `
              <button
                type="button"
                class="team-builder__option
                  ${isSelected ? 'is-selected' : ''}
                  ${!isAvailable ? 'is-sold-out' : ''}"
                data-product-option
                data-option-index="${optionIndex}"
                data-option-value="${value}"
                ${!isAvailable ? 'disabled' : ''}
                aria-disabled="${!isAvailable}"
                title="${!isAvailable ? `${value} - Sold out` : value}"
              >
                ${value}
              </button>
            `;
          }).join('')}
        </div>
      </div>
    `;
  }).join('');
};
})();